var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "111",
                reset: true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                )
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.selectedJob || _vm.total <= 0,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onAdd()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: !_vm.selectedJob, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.copyJobHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_reVerify_accept"
                          ]),
                          expression:
                            "$checkPermission(['button_reVerify_accept'])"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.acceptHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_reVerify_reject"
                          ]),
                          expression:
                            "$checkPermission(['button_reVerify_reject'])"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.rejectHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_reVerify_reviewThrough"
                            ]) && _vm.btn.pretrialReviewConfig,
                          expression:
                            "$checkPermission(['button_reVerify_reviewThrough']) && btn.pretrialReviewConfig"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.btVerifyReviewThroughHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewThrough")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_reVerify_reviewRefusal"
                            ]) && _vm.btn.pretrialReviewConfig,
                          expression:
                            "$checkPermission(['button_reVerify_reviewRefusal']) && btn.pretrialReviewConfig"
                        }
                      ],
                      attrs: {
                        disabled: !_vm.btn.btVerifyReviewRefusal,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.btVerifyReviewRefusalHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewRefusal")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.$checkPermission([
                          "button_reVerify_accept"
                        ]),
                        type: "success"
                      },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "130101",
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "show-row-groups": _vm.dataListDragGroup,
                  "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                },
                on: { gridReady: _vm.onGridReady }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "130101",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "selected-row-count": _vm.selectedRowCount
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.opVerifyFrameDialog.visible
        ? _c("op-verify-frame-dialog", {
            attrs: {
              visible: _vm.opVerifyFrameDialog.visible,
              "job-model": _vm.opVerifyFrameDialog.job || {},
              "batch-pass-audit": _vm.opVerifyFrameDialog.batchPassAudit,
              "submit-call-back": _vm.opVerifyFrameDialog.submitCallBack,
              "job-list": _vm.opVerifyFrameDialog.jobList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.opVerifyFrameDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("op-verify-frame-reject", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "job-list": _vm.rejectWindow.jobList,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.confirmDialogWindow.visible
        ? _c("confirm-dialog-window", {
            attrs: {
              visible: _vm.confirmDialogWindow.visible,
              "message-title": _vm.confirmDialogWindow.messageTitle,
              content: _vm.confirmDialogWindow.content,
              "show-confirm-btn": _vm.confirmDialogWindow.showConfirmBtn,
              "confirm-call-back": _vm.confirmDialogWindow.confirmCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.confirmDialogWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("edit-dialog", {
        attrs: {
          visible: _vm.editDialog.visible,
          "job-model": _vm.editDialog.job,
          context: _vm.context
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          reloadFunc: _vm.reloadFunc
        }
      }),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: "RE",
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "new-job": _vm.batchCheckingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }